/**
 * Legacy camelCase method aliases the SDK exposes on the bridge client's
 * `actions` object — `actions.showToast(data, handlers)` etc.
 *
 * This is the COMPLETE actionName↔functionName contract from the SDK
 * (`tapcart-webbridge/src/lib/config/actions.js`, 47 pairs as of SDK
 * 2.x), plus `enable/push` which exists only in the RN provider's map
 * (`apps/tapcart-ssr-app/lib/context-providers/webbridge.tsx`). Drift
 * against the installed SDK is enforced by
 * `scripts/check-sdk-parity.mjs` (the package's `test` script): when a
 * new SDK version adds an action, CI fails here instead of block code
 * TypeError'ing in a merchant's storefront.
 *
 * v0 shipped without these on the theory that `useTapcart().action()` is
 * the canonical path; in practice shared components in
 * `@tapcart/mobile-components` (e.g. the AddItemToWishlist drawer) call
 * `actions.showToast` / `actions.openScreen` directly. Every alias
 * forwards to the action dispatcher: real implementations (wishlist ops,
 * cart/add) do real work, the rest hit the registry's graceful stubs
 * instead of crashing block code.
 */
export const LEGACY_ACTION_ALIASES = {
    "cart/add": "addToCart",
    "discount/apply": "applyDiscount",
    "discount/remove/all": "removeDiscounts",
    "discount/remove": "removeDiscount",
    "giftcard/apply": "applyGiftCard",
    "cart/open": "openCart",
    "authentication/open": "authenticationOpen",
    "collection/open": "openCollection",
    "product/open": "openProduct",
    "app/toast": "showToast",
    "view/updated": "updateView",
    "customer/identity": "getCustomerIdentity",
    "view/rendered": "renderView",
    "screen/open": "openScreen",
    "view/scrollToBlockTop": "scrollToBlockTop",
    "view/scrollToBlockBottom": "scrollToBlockBottom",
    "cart/remove": "removeFromCart",
    "analytics/track": "trackAnalyticEvent",
    "cart/updateAttributes": "updateCartAttributes",
    "cart/updateNote": "updateCartNote",
    "vault/initialize": "vaultInitialize",
    "vault/get": "vaultGet",
    "vault/set": "vaultSet",
    "vault/remove": "vaultRemove",
    "vault/clear": "vaultClear",
    "vault/keys": "vaultKeys",
    "vault/observe": "vaultObserve",
    "wishlist/create": "wishlistCreate",
    "wishlists/get": "wishlistsGet",
    "wishlist/item/add": "wishlistItemAdd",
    "wishlist/item/remove": "wishlistItemRemove",
    "enable/push": "enablePush",
    "giftcard/remove": "removeGiftCard",
    "giftcard/get": "getGiftCard",
    "loyalty/rewards": "getLoyaltyRewards",
    "loyalty/history": "getLoyaltyHistory",
    "loyalty/customer": "getLoyaltyCustomer",
    "loyalty/tiers": "getLoyaltyTiers",
    "loyalty/customer/tier": "getLoyaltyCustomerTier",
    "loyalty/redeem/reward": "redeemLoyaltyReward",
    "loyalty/record/activity": "recordLoyaltyActivity",
    "loyalty/set/birthday": "setLoyaltyBirthday",
    "loyalty/accept/legal": "loyaltyAcceptLegal",
    "cart/applePayStartSessionURL": "applePayStartSessionURL",
    "cart/getApplePayDomainName": "getApplePayDomainName",
    "cart/applePayOnPaymentAuthorized": "applePayOnPaymentAuthorized",
    "cart/applePayOnShippingContactSelected": "applePayOnShippingContactSelected",
    "cart/applePayOnPaymentMethodSelected": "applePayOnPaymentMethodSelected",
    "cart/applePayOnShippingMethodSelected": "applePayOnShippingMethodSelected",
};
